<template>
  <span class="table-data-default">{{ value }}</span>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    },
  },
}
</script>

<style lang="scss"></style>
